import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Image, { IImage } from 'tbk-components/src/components/Image';

export interface ICommercialSolutionItem {
	title: string;
	/**
	 * @control textarea
	 */
	description: string;
	link?: ILink;
}

export interface ICommercialSolutionsProps extends IBaseElementProps {
	children?: any;
	image?: IImage;
	title?: string;
	featuredLink?: ILink;
	solutionItems?: ICommercialSolutionItem[];
}

/**
 * Commercial Solutions
 * @block
 * @requiresHooks
 * @icon media-spreadsheet
 */
const CommercialSolutions: React.FC<ICommercialSolutionsProps> = ({
	children,
	className,
	classNames = [],
	image,
	title,
	featuredLink,
	solutionItems,
}) => (
	<div className={className || cn('commercial-solutions', ...classNames)}>
		<div className="commercial-solutions__container container-fluid">
			<div className="container">
				{image && (
					<div className="row">
						<div className="commercial-solutions__image-container col-12 p-lg-0">
							<Image
								className="commercial-solutions__image img-fluid"
								{...image}
							/>
						</div>
					</div>
				)}
				{title && (
					<div className="commercial-solutions__title-row row">
						<div className="commercial-solutions__title col-12">
							<h2>{title}</h2>
							{featuredLink?.label && (
								<Button
									className="btn btn-lg btn-secondary"
									{...featuredLink}
								/>
							)}
						</div>
					</div>
				)}
				{(solutionItems || []).length > 0 && (
					<div className="commercial-solutions__items-row row">
						{solutionItems.map((solutionItem, index) => (
							<div
								className="commercial-solutions__item col-6 col-md-4"
								key={index}
							>
								<h4>{solutionItem.title}</h4>
								<p>{solutionItem.description}</p>
								{solutionItem.link && (
									<Button
										className="btn btn-sm btn-secondary"
										{...solutionItem.link}
									/>
								)}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	</div>
);

export default CommercialSolutions;
